export { default } from './VejamTambemAmpless';
